const Ppm = require('./ppm').default;
const Quill = require('quill');

const unit = {
    axisByTypes: {},
    clearAxisByTypes() {
        this.axisByTypes = {};
    },
    init() {
        if (document.querySelector('.unitEdit')) {
            this.refresh();

            let form = document.querySelector('.unitEdit');
            this.ql(form);

            for (const el of form.elements) {
                el.addEventListener('change', () => this.refresh());
            }
        }
    },
    ql(form) {
        let quill = new Quill("#designationContainer", {
            modules: {
                toolbar: [
                    [{'script': 'sub'}, {'script': 'super'}],
                ],
                keyboard: {
                    bindings: {
                        tab: false,
                        handleEnter: {
                            key: 13,
                            handler: function () {
                                // Do nothing
                            }
                        },
                        handleEnterShift: {
                            key: 13,
                            shiftKey: true,
                            handler: function () {
                                // Do nothing
                            }
                        }
                    }
                },
            },
            placeholder: 'Wprowadź oznaczenie',
            theme: 'snow',  // or 'bubble'
        });

        quill.clipboard.addMatcher(Node.TEXT_NODE, function (node, delta) {
            return new Delta().insert(node.data);
        });

        quill.clipboard.addMatcher("B", function (node, delta) {
            return delta.compose(new Delta().retain(delta.length(), {bold: true}));
        });

        quill.clipboard.addMatcher("a", function (node, delta) {
            return delta.compose(new Delta().retain(delta.length(), {color: "red"}));
        });

        quill.on('text-change', function () {

            if (quill.root.children.length > 0)
                form.designation.value = quill.root.children[0].innerHTML;
            this.refresh();
        }.bind(this));
    },
    refresh() {
        let form = document.querySelector('.unitEdit');
        let show = document.querySelector('#unitShow');
        let showReversed = document.querySelector('#unitShowReversed');
        show.innerHTML = '';
        let mi1 = document.createElementNS(show.namespaceURI, 'mn');
        mi1.textContent = 1;
        show.appendChild(mi1);
        let mi2 = document.createElementNS(show.namespaceURI, 'mn');
        mi2.innerHTML = form.designation.value;
        show.appendChild(mi2);
        let mi3 = document.createElementNS(show.namespaceURI, 'mn');
        mi3.textContent = '=';
        show.appendChild(mi3);
        let mi4 = document.createElementNS(show.namespaceURI, 'mn');
        mi4.textContent = (Number.parse(form.a1.value) / Number.parse(form.a1d.value)) + (Number.parse(form.a0.value) / Number.parse(form.a0d.value));
        show.appendChild(mi4);
        let mi5 = document.createElementNS(show.namespaceURI, 'mn');
        mi5.innerHTML = form.type.selectedOptions[0].dataset.designation;
        show.appendChild(mi5);


        showReversed = document.querySelector('#unitShowReversed');

        showReversed.innerHTML = '';
        let miR1 = document.createElementNS(showReversed.namespaceURI, 'mn');
        miR1.textContent = 1;
        showReversed.appendChild(miR1);
        let miR2 = document.createElementNS(showReversed.namespaceURI, 'mn');
        miR2.innerHTML = form.type.selectedOptions[0].dataset.designation;
        showReversed.appendChild(miR2);
        let miR3 = document.createElementNS(showReversed.namespaceURI, 'mn');
        miR3.textContent = '=';
        showReversed.appendChild(miR3);
        let miR4 = document.createElementNS(showReversed.namespaceURI, 'mn');
        miR4.textContent = (1 - (Number.parse(form.a0.value) / (Number.parse(form.a0d.value)))) * Number.parse(form.a1d.value) / Number.parse(form.a1.value);
        showReversed.appendChild(miR4);
        let miR5 = document.createElementNS(showReversed.namespaceURI, 'mn');
        miR5.innerHTML = form.designation.value;
        showReversed.appendChild(miR5);


    },
    registerAxis(typeName, axis, callback) {
        if (!this.axisByTypes[typeName])
            this.axisByTypes[typeName] = [];

        this.axisByTypes[typeName].push({axis, callback});
    },
    menu(e, typeName) {
        let type = unitsList[typeName];
        let ppmButtons = [];
        for (let unitData of type.list) {
            ppmButtons.push({
                ico: '',
                html: '<math><mn>' + unitData.designation + '</mn></math> ',
                func: () => {
                    unitData.__proto__ = unitPrototype;
                    this.axisByTypes[typeName].forEach(type => {
                        type.axis.config = {
                            unit: unitData,
                        };
                        if (type.callback)
                            type.callback();
                    });
                }
            });
        }
        Ppm.show(e, ppmButtons);
        e.stopPropagation();
        e.preventDefault();
    },

    selectUnitOfTypeName(typeName, unitId) {
        let type = unitsList[typeName];

        if(type && type.list) {
            for (let unitData of type.list) {
                if (unitData.id == unitId) {
                    unitData.__proto__ = unitPrototype;
                    if (this.axisByTypes[typeName]) {
                        this.axisByTypes[typeName].forEach(type => {
                            type.axis.config = {
                                unit: unitData,
                            };
                            if (type.callback)
                                type.callback();
                        });
                    }
                }
            }
        }
    },
    setPrototypeOfUnits() {
        if (window.unitsList) {
            for (let type of Object.values(unitsList)) {
                for (let unit of type.list) {
                    unit.__proto__ = unitPrototype;
                }
            }
        }
    }
};
const unitPrototype = {
    apply(x) {
        return (x - this.a0 / this.a0d) * this.a1d / this.a1;
    },
    restore(x) {
        return x * this.a1 / this.a1d + this.a0 / this.a0d;
    }
};

export {unit};